export default "__VITE_ASSET__CXBoxdLg__"